// removed by extract-text-webpack-plugin
module.exports = {"integrationTableWrap":"theme--integrationTableWrap--1jJ2Qnii","integrationTable":"theme--integrationTable--3LrLVrWP","integrationTabletable":"theme--integrationTabletable--2YQEazEs","integrationImage":"theme--integrationImage--3F8QavPd"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/integration/theme.scss
// module id = 1030
// module chunks = 0